import { useSearchParams } from '@occc-app/hooks/useSearchParams';

export const RETAILER_NETWORK_USER_LOCATIONS_AND_GROUPS_TAB_PARAM = 'tab';

const LOCATIONS_PREFIX = 'locations';

export const LOCATIONS_BEFORE_PARAM = `${LOCATIONS_PREFIX}-before`;
export const LOCATIONS_AFTER_PARAM = `${LOCATIONS_PREFIX}-after`;

export const LOCATIONS_PARAM_NAMES: Parameters<typeof useSearchParams>[0] = {
  searchParamName: `${LOCATIONS_PREFIX}-search`,
  afterParamName: LOCATIONS_AFTER_PARAM,
  beforeParamName: LOCATIONS_BEFORE_PARAM,
};

const LOCATION_GROUPS_PREFIX = 'locationGroups';

export const LOCATION_GROUPS_BEFORE_PARAM = `${LOCATION_GROUPS_PREFIX}-before`;
export const LOCATION_GROUPS_AFTER_PARAM = `${LOCATION_GROUPS_PREFIX}-after`;

export const LOCATION_GROUPS_PARAM_NAMES: Parameters<typeof useSearchParams>[0] = {
  searchParamName: `${LOCATION_GROUPS_PREFIX}-search`,
  afterParamName: LOCATION_GROUPS_AFTER_PARAM,
  beforeParamName: LOCATION_GROUPS_BEFORE_PARAM,
};
